<template>
  <NsiTable :pageTitle="pageTitle" :apiRoute="apiRoute" :cardName="cardName" :canEdit="canEdit" />
</template>

<script>
  import NsiTable from '../components/NsiTable.vue';

  export default {
    name: 'NsiExportPotentialServiceTypes',
    components: {
      NsiTable,
    },
    data() {
      return {
        pageTitle: 'Экспортный потенциал по услугам - Вид услуги',
        canEdit: true,
        apiRoute: 'nsiExportPotentialServiceType',
        cardName: 'NsiExportPotentialServiceTypeCard',
      };
    },
    created() {},
    methods: {},
  };
</script>
